<template>
  <div class="new-count-down" v-if="countDown.total > 0">
    <span>{{ $t("countDown") }}</span>
    <ul>
      <li>{{ countDown.days }} :</li>
      <li>{{ countDown.hours }} :</li>
      <li>{{ countDown.minutes }} :</li>
      <li>{{ countDown.seconds }}</li>
    </ul>
  </div>
</template>

<script>
import locales from "./lang";

export default {
  props: ["endTime"],
  locales,
  data() {
    return {
      countDown: {
        total: "",
        days: "",
        hours: "",
        minutes: "",
        seconds: "",
      },
    };
  },
  mounted() {
    this.getCountDown(this.endTime);
  },
  methods: {
    countDownFunc(endTime) {
      const nowTime = new Date();
      const endTime1 = new Date(endTime);
      let times = (endTime1 - nowTime) / 1000;

      let days = 0;
      let hours = 0;
      let minutes = 0;
      let seconds = 0;
      days = Math.floor(times / 60 / 60 / 24) + "";
      hours = Math.floor((times / 60 / 60) % 24) + "";
      minutes = Math.floor((times / 60) % 60) + "";
      seconds = Math.floor(times % 60);

      if (days <= 9) {
        days = "0" + days;
      }
      if (hours <= 9) {
        hours = "0" + hours;
      }
      if (minutes <= 9) {
        minutes = "0" + minutes;
      }
      if (seconds <= 9) {
        seconds = "0" + seconds;
      }
      this.countDown = {
        total: times,
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
      };
      this.$emit("timer", this.total);
    },
    getCountDown(endTime) {
      let timer = setInterval(() => {
        this.countDownFunc(endTime);
        if (this.countDown.total <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
.new-count-down {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #111111;
  letter-spacing: 0;
  text-align: center;
  line-height: 12px;
  font-weight: 400;
  margin-top: 14px;
  ul {
    display: flex;
    list-style: none;
    margin-bottom: 0;
    padding-left: 8px;
  }
}

@media screen and (max-width: 1024px) {
  .new-count-down {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// countDownNew.vue?066f71e6